
export enum ApplicationCategorySelectedEventType {
  TopAngebote = 1,
  CategoryImage,
  CategoryFilterPLP
}
